import { createOrderedDataIdsSelector } from './create-ordered-data-ids-selector/create-ordered-data-ids.selector';
import { createSortDirectionSelector } from './create-sort-direction-selector/create-sort-direction.selector';
import { createSortOptionSelector } from './create-sort-option-selector/create-sort-option.selector';

export const SortSelectors = {
  createSortDirectionSelector,
  createSortOptionSelector,
  createOrderedDataIdsSelector
};
